import React from 'react';
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function FloatingButton({ icon, show, ...rest }) {
  let visibilityButton = 'visible';
  if (typeof (show) !== 'undefined') {
    visibilityButton = (show) ? 'visible' : 'hidden';
  }

  return (
    <Button
      {...rest}
      style={{
        visibility: visibilityButton, position: 'fixed', bottom: '24px', right: '24px', zIndex: '9999', width: '72px', height: '72px', boxShadow: '0 5px 25px 0 rgba(46,91,255,0.4)',
      }}
      type="primary"
      shape="circle"

    >
      <FontAwesomeIcon
        icon={icon}
        style={{
          height: '24px',
          width: '24px',
        }}
      />
    </Button>
  );
}
